/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const RemoteSystemInformationReadSubscription = gql`
  subscription SystemReadSubscription {
    SystemInformationRemoteRead {
      cpu
      diskInfo
      memory
      message
      serverStatus
      status
    }
  }
`


/*
 * EXPORTS
 */
export default RemoteSystemInformationReadSubscription
